import TicketMensagemService from "@/services/TicketMensagemService";

export const ticketMensagem = {
  namespaced: true,
  state: {
    ticketMensagem: {},
  },
  actions: {
    getTicketMensagem({ commit }, payload) {
      return TicketMensagemService.GetTicketMensagem(payload).then(
        (ticketMensagem) => {
          return Promise.resolve(ticketMensagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    postTicketMensagem({ commit }, payload) {
      return TicketMensagemService.PostTicketMensagem(payload).then(
        (ticketMensagem) => {
          return Promise.resolve(ticketMensagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    putTicketMensagem({ commit }, payload) {
      return TicketMensagemService.PutTicketMensagem(payload).then(
        (ticketMensagem) => {
          return Promise.resolve(ticketMensagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    deleteTicketMensagem({ commit }, payload) {
      return TicketMensagemService.DeleteTicketMensagem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    getTicketMensagemOData({ commit }, payload) {
      return TicketMensagemService.GetTicketMensagemOData(payload).then(
        (ticketMensagem) => {
          return Promise.resolve(ticketMensagem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    postTicketMensagemUpload({ commit }, payload) {
      return TicketMensagemService.PostTicketMensagemUpload(payload).then(
        (ticketMensagemUpload) => {
          return Promise.resolve(ticketMensagemUpload);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    deleteTicketMensagemUpload({ commit }, payload) {
      return TicketMensagemService.DeleteTicketMensagemUpload(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default ticketMensagem;
